import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { CAPService } from "../../core/services/cap-service";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
//import { Directive, ElementRef, HostListener } from '@angular/core';
import { MatDatepicker } from "@angular/material/datepicker";
import { PagerService } from "../../core/services/pager.service";
@Component({
  selector: "app-leavers",
  templateUrl: "./leavers.component.html",
  styleUrls: ["./leavers.component.css"],
})
export class LeaversComponent implements OnInit {
  @ViewChild("grdEndDate") grdEndDate: MatDatepicker<Date>;
  @ViewChild("grdFEndDate") grdFEndDate: MatDatepicker<Date>;
  IsdivSearch = false;
  IsAlertForAccess = false;
  IsshowMsg = false;
  IsdivSubmit = false;
  IsdivDetails = false;

  //Properities
  public successfulData: any = new Data();
  public DeviceTypeList;
  public Country;
  public LoginEnterpriseID;
  public ErrorMessage;
  public Role;
  public DeviceType;
  public country = "";
  public Type = "";
  public Countries;
  public selectedCountry = "";
  public LeaverEid = "";
  public filter;
  public checked;
  public LeaverDetails: LeaverDetails = new LeaverDetails();
  // pager object
  pager: any = {};
  // array of all items to be paged
  private allItems: any[];
  // paged items
  pagedItems: any[];

  constructor(
    private CAPService: CAPService,
    private location: Location,
    private router: Router,
    private pagerService: PagerService
  ) {
    this.Country = CAPService.country;
    this.LoginEnterpriseID = CAPService.enterpriseid;
    this.ErrorMessage =
      "This section is not enabled. Please contact the Online support or check User Guidelines section for any access or tool issue.";
    this.DeviceTypeList = [/*{ name: 'Skype'},*/ { name: "Cisco" }];
    this.Role = CAPService.Role;
    this.DeviceType = CAPService.DeviceType;
    this.LeaverDetails.DeviceType = "";
    this.LeaverDetails.Country = "";
    this.LeaverDetails.PeriodDesc = "";
    this.LeaverDetails.leaverEid = "";
    this.LeaverDetails.endDate = "";
    if (this.Role == "Regional Voice Admin") {
      this.country = this.Country;
      this.Type = "Regional";
    } else if (this.Role == undefined) {
      location.go("/profile");
      window.location.reload();
    }
  }

  ShowgrdEndDate(): void {
    this.grdEndDate.open();
  }
  ShowgrdFEndDate(): void {
    this.grdFEndDate.open();
  }

  ngOnInit(): void {
    this.CAPService.AudiLogin("Leavers", this.LoginEnterpriseID).subscribe(
      (success) => {}
    );
    this.CAPService.CountryList("N", "N").subscribe((data) => {
      this.Countries = data;
    });
  }

  DeviceTypeEvent(deviceTyp) {
    var date;    
    this.filter = deviceTyp;
    if (this.DeviceType == this.filter || this.DeviceType == "All") {
      if (this.filter == "Skype") {
        this.IsAlertForAccess = false;
        this.IsshowMsg = false;
        this.IsdivSearch = true;
        this.IsdivSubmit = true;
        this.IsdivDetails = true;
        this.LeaverEid = "";
        this.selectedCountry = "";
        this.checked = false;
        if (
          this.checked != undefined &&
          this.checked != null &&
          this.checked != ""
        ) {
          date = "Checked";
        } else {
          date = "N";
        }
        this.CAPService.GetLeaversDetails(
          "N",
          date,
          this.filter,
          this.country,
          this.LoginEnterpriseID
        ).subscribe((data) => {
          if (data.length > 0) {
            this.successfulData = { leavers: data, selected: {} };
            this.allItems = data;
            // initialize to page 1
            this.setPage(1);
          } else {
            alert("No Records found");
          }
        });
      } else {
        this.IsshowMsg = true;
        this.IsAlertForAccess = false;
        this.IsdivSearch = false;
        this.IsdivSubmit = false;
        this.IsdivDetails = false;
      }
    } else {
      this.IsAlertForAccess = true;
      this.IsshowMsg = false;
      this.IsdivSearch = false;
      this.IsdivSubmit = false;
      this.IsdivDetails = false;
    }
  }
  AddLeavers() {
    var message = '';
    var dateString = this.LeaverDetails.endDate;
    var myDate= new Date(dateString);
    var today = new Date();
    if(this.successfulData.selected.leaverEid == ''){
      message = "Please Enter Leaver ID";
    }
    if (this.successfulData.selected.endDate == "") {
      message = message + "\n" + "Please Select End Date";
    } else if (myDate < today) {
      message =
        message + "\n" + "Please select End Date greater than current date";
    }
    if (this.successfulData.selected.Country == "") {
      message = message + "\n" + "Please Select Country";
    }
    if (this.filter == "") {
      message = message + "\n" + "Please Select DeviceType";
    }
    if (message != "") {
      alert(message);
    } else {
      this.LeaverDetails.DeviceType = this.filter;
      this.LeaverDetails.Country = this.LeaverDetails.Country;
      this.LeaverDetails.PeriodDesc = this.LeaverDetails.leaverEid;
      this.CAPService.EnterpriseIdValidaton(
        this.LeaverDetails.leaverEid
      ).subscribe((data) => {
        if (data.toString() == "Valid") {
          this.CAPService.UpdatePayDetails(
            "InsertLeaversDetails",
            this.LeaverDetails,
            this.LoginEnterpriseID
          ).subscribe((data) => {
            if (data.toString() == "Success") {
              alert("Inserted Successfully.");
              this.DeviceTypeEvent("N");
              this.clear();
            } else {
              alert(data);
            }
          });
        } else {
          alert(data);
        }
      });
    }
  }

  EditLeavers(data) {
    this.successfulData.selected = data;
    this.successfulData.selected.endDate =
      this.successfulData.selected.endDate.slice(0, 10);
  }
  UpdateLeavers(idx) {
    var message = '';
    var dateString = this.successfulData.selected.endDate;
    var myDate = new Date(dateString);
    var today = new Date();
    if(this.successfulData.selected.leaverEid == ''){
      message = "Please Enter Leaver ID";
    }
    if (this.successfulData.selected.endDate == "") {
      message = message + "\n" + "Please Select End Date";
    } else if (myDate < today) {
      message =
        message + "\n" + "Please select End Date greater than current date";
    }
    if (this.successfulData.selected.Country == "") {
      message = message + "\n" + "Please Select Country";
    }
    if (this.filter == "") {
      message = message + "\n" + "Please Select DeviceType";
    }
    if (message != "") {
      alert(message);
    } else {
      this.successfulData.leavers[idx] = this.successfulData.selected;
      this.successfulData.selected.PeriodId = this.successfulData.selected.Id;
      this.successfulData.selected.DeviceType = this.filter;
      this.successfulData.selected.Country =
        this.successfulData.selected.Country;
      this.successfulData.selected.PeriodDesc =
        this.successfulData.selected.leaverEid;
      this.CAPService.EnterpriseIdValidaton(
        this.successfulData.selected.leaverEid
      ).subscribe((data) => {
        if (data.toString() == "Valid") {
          this.CAPService.UpdatePayDetails(
            "UpdateLeaversDetails",
            this.successfulData.selected,
            this.LoginEnterpriseID
          ).subscribe((data) => {
            if (data.toString() == "Success") {
              alert("Updated Successfully.");
              this.DeviceTypeEvent("N");
              this.clear();
            } else {
              alert(data);
            }
          });
        } else {
          alert(data);
        }
      });
    }
  }

  DeleteLeavers(data) {
    this.successfulData.selected = data;
    this.successfulData.selected.PeriodId = data.Id;
    this.CAPService.UpdatePayDetails(
      "DeleteLeaversDetails",
      this.successfulData.selected,
      this.LoginEnterpriseID
    ).subscribe((data) => {
      if (data.toString() == "Success") {
        this.DeviceTypeEvent("N");
        this.clear();
        alert("Deleted Successfully.");
      } else {
        alert(data);
      }
    });
  }

  ShowData() {
    var date;
    if(this.LeaverEid == '' && this.selectedCountry == ''){
      this.IsdivDetails = false;
      alert("Please enter value to search!");
    }
    else{
      this.Country = this.selectedCountry == ''? this.country :this.selectedCountry;
      var LeaverID = this.LeaverEid == '' ? 'N' : this.LeaverEid;
      this.IsdivSearch = true;
      this.IsdivSubmit = true;
      if (
        this.checked != undefined &&
        this.checked != null &&
        this.checked != ""
      ) {
        date = "Checked";
      } else {
        date = "N";
      }
      this.CAPService.GetLeaversDetails(
        LeaverID,
        date,
        this.filter,
        this.Country,
        this.LoginEnterpriseID
      ).subscribe((data) => {
        if (data.length > 0) {
          this.successfulData = { leavers: data, selected: {} };
          this.IsdivDetails = true;
        } else {
          this.IsdivDetails = false;
          alert("No Records Found");
        }
      });
    }
  }
  change() {
    var date;
    this.Country = this.selectedCountry == ''? this.country :this.selectedCountry;
    var LeaverID = this.LeaverEid == '' ? 'N' : this.LeaverEid;
    this.IsdivSearch = true;
    this.IsdivSubmit = true;
    if (
      this.checked != undefined &&
      this.checked != null &&
      this.checked != ""
    ) {
      date = "Checked";
    } else {
      date = "N";
    }
    this.CAPService.GetLeaversDetails(
      LeaverID,
      date,
      this.filter,
      this.Country,
      this.LoginEnterpriseID
    ).subscribe((data) => {
      if (data.length > 0) {
        this.successfulData = { leavers: data, selected: {} };
        this.IsdivDetails = true;
      } else {
        this.IsdivDetails = false;
        alert("No Records Found");
      }
    });
  }
  clear() {
    this.LeaverDetails.leaverEid = "";
    this.LeaverDetails.endDate = "";
    this.LeaverDetails.Country = "";
    this.successfulData.selected.leaverEid = "";
    this.successfulData.selected.endDate = "";
    this.successfulData.selected.Country = "";
    this.LeaverEid = "";
    this.selectedCountry = "";
    this.Country = "N";
    this.checked = false;
    this.DeviceTypeEvent(this.filter);
  }
  getTemplate(data) {
    return this.CAPService.EditTemplate(data, this.successfulData.selected.Id);
  }

  reset() {
    this.successfulData.selected = {};
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.successfulData.leavers = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }
}

export class Data {
  public leavers;
  public selected;
}

export class LeaverDetails {
  public DeviceType;
  public Country;
  public PeriodDesc;
  public leaverEid;
  public endDate;
}
